module.exports = __webpack_public_path__ + "static/media/addRecipientGuide2_Jap.ecff865a.png";